import { Head, Link } from "@inertiajs/react";
import { Card, Link as RadixLink } from "@radix-ui/themes";

import { AppLayout } from "@/components/app-layout";
import { ProjectForm } from "@/pages/projects/form";
import type { SharedProps } from "@/lib/types";

type UserOption = { id: number; email: string };
type GroupOption = { id: number; name: string };

type ProjectNewProps = SharedProps & {
  users: UserOption[];
  projectGroups: GroupOption[];
};

export default function ProjectsNew({ auth, users, projectGroups }: ProjectNewProps) {
  return (
    <>
      <Head title="New Project" />
      <AppLayout
        user={auth.user}
        activeModule="weekly_planner"
        onModuleChange={() => {}}
        pageTitle="New Project"
        pageActions={
          <RadixLink asChild size="2">
            <Link href="/projects">Back to projects</Link>
          </RadixLink>
        }
      >
        <Card className="p-4">
          <ProjectForm
            action="/projects"
            method="post"
            users={users}
            groups={projectGroups}
            initialValues={{
              name: "",
              status: "lead",
              project_group_id: "",
              project_owner_id: "",
              project_manager_id: "",
              frontend_lead_id: "",
              backend_lead_id: "",
              harvest_project_id: "",
              quickbooks_customer_id: "",
              asana_workspace_id: "",
              google_drive_folder_id: "",
              vcs_repository_links: "",
            }}
          />
        </Card>
      </AppLayout>
    </>
  );
}
